import { getCategoryPageServerSideProps } from 'server/utils/getCategoryPageServerSideProps';
import { IProductLandingPage } from 'shared/types/ProductLandingPage';
import { isSearchCrawler } from 'shared/utils/isSearchCrawler';
import { PlpPageComponent as PLPLandingPageComponent } from 'product-landing-pages/components/PlpPageComponent';
import { setServerSideTranslations } from 'localization/utils/setServerSideTranslations';
import { startCase } from 'shared/utils/startCase';
import { slugify } from 'shared/utils/consumerSearchSlugify';

const Boots = ({
  breadcrumbs,
  browseKey,
  browseValue,
  category,
  constructorResponse,
  displayName,
  globalPricingId,
  isCrawler = false,
  consumerSearchInitialData = '{}',
}: IProductLandingPage) => {
  const {
    name = displayName,
    description = '',
    metadataDescription = '',
    titleTag = '',
  } = breadcrumbs || {};

  return (
    <PLPLandingPageComponent
      breadcrumbs={[
        { name: startCase(category), slug: `/${category}` },
        {
          name: startCase(browseValue),
          slug: `/${category}/${slugify(browseValue)}`,
          isStatic: true,
        },
      ]}
      browseKey={browseKey}
      browseValue={browseValue}
      constructorResponse={constructorResponse}
      description={description}
      displayName={name}
      globalPricingId={globalPricingId}
      isCrawler={isCrawler}
      metadataDescription={metadataDescription}
      metaTitle={titleTag}
      consumerSearchFilters={{ productTypes: 'sneakers', activityList: 'boot' }}
      consumerSearchInitialData={JSON.parse(consumerSearchInitialData)}
    />
  );
};

export async function getServerSideProps({ query, req, res, resolvedUrl, locale }) {
  const isCrawler = isSearchCrawler(req?.headers);
  const i18n = await setServerSideTranslations({ locale });

  const categoryProps = await getCategoryPageServerSideProps({
    category: resolvedUrl?.split('/')?.[1],
    i18n,
    isCrawler,
    query,
    req,
    res,
    resolvedUrl,
    subCategory: resolvedUrl?.split('/')?.[2],
    hasCSFilters: { productTypes: 'sneakers', activityList: 'boot' },
  });

  return categoryProps;
}

export default Boots;
